/* jshint esversion: 8 */
define([
  "service/productConnect/connectionButtonGenerator",
  "service/landingPageNavButtons",
  "dojo/i18n!nls/cloudCenterStringResource",
  "dojo/string",
  "constants"
], function (
  ConnectionButtonGenerator,
  LandingPageNavButtons,
  I18NStringResource, DojoString,
  Constants
) {

  class WebAppServerConnectionButtonGenerator extends ConnectionButtonGenerator {

    constructor (args) {
      super(args);
    }

    getConnectButtonTooltipText() { return I18NStringResource.computeResourcePageActionConnectTooltipWebAppServer; }

  }

  return WebAppServerConnectionButtonGenerator;
});
